import { render } from "./Panel.vue?vue&type=template&id=1d944037&scoped=true"
import script from "./Panel.vue?vue&type=script&lang=js"
export * from "./Panel.vue?vue&type=script&lang=js"

import "./Panel.vue?vue&type=style&index=0&id=1d944037&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1d944037"

export default script